module.exports = __webpack_public_path__ + "img/toCV3RectangleWenLiOrange.feeec51b.png";